




/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";

// UPDATEPLANFORREAPPROVAL
// UPDATEPLANFORREAPPROVAL
const UPDATEPLANFORREAPPROVAL= createAsyncThunk(
  "updatePlanForReApproval/updatePlanForReApproval",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const updatePlanForReApprovalSlice = createSlice({
  name: "updatePlanForReApprovalSlice",
  initialState: {
    updatePlanForReApproval: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfupdatePlanForReApproval: (state) => {
        state.updatePlanForReApproval.loading = false
        state.updatePlanForReApproval.error = false
        state.updatePlanForReApproval.data = []
        state.updatePlanForReApproval.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(UPDATEPLANFORREAPPROVAL.fulfilled, (state, action) => {
      state.updatePlanForReApproval = {
        ...state.updatePlanForReApproval,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(UPDATEPLANFORREAPPROVAL.pending, (state, action) => {
      state.updatePlanForReApproval = {
        ...state.updatePlanForReApproval,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(UPDATEPLANFORREAPPROVAL.rejected, (state, action) => {
      state.updatePlanForReApproval = {
        ...state.updatePlanForReApproval,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const updatePlanForReApprovalAction = {
    UPDATEPLANFORREAPPROVAL,
};

export { updatePlanForReApprovalAction };
export default updatePlanForReApprovalSlice.reducer;
export const {setInitialStateOfupdatePlanForReApproval} = updatePlanForReApprovalSlice.actions